// extracted by mini-css-extract-plugin
export default {"colContainer":"styles_colContainer__o1vTN"};